// extracted by mini-css-extract-plugin
export var cartBtn = "wrapper-module--cartBtn--kZ0ZX";
export var checkoutBtn = "wrapper-module--checkoutBtn--CiGEu";
export var styledPriceContainer = "wrapper-module--styledPriceContainer--yFA84";